const userManagement = {
  assignRole: 'Assegna Ruolo',
  currentRole: 'Ruolo Corrente',
  newRole: 'Nuovo Ruolo',
  role: 'Ruolo {0}',
  userManagement: 'Gestione Utenti',
  usersViewed: 'Utenti visualizzati {0}',
};

export default userManagement;
